import React, { ReactElement, useState, useEffect } from "react";

import { storage } from "../../../apis/firebase";
import { ref, getDownloadURL } from "firebase/storage";
import HtmlParser from "html-react-parser";

export default ({ data, idx }): ReactElement => {
  const [response, setIsResponse] = useState<any>({});

  useEffect(() => {
    setIsResponse(data);
  }, [data]);

  return (
    <>
      {!!response && response?.codesnippet && (
        <>{HtmlParser(response?.codesnippet)}</>
      )}
    </>
  );
};
